import React from "react";
import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import Button from "../../ui/components/Button";
import ProfileButton from "./ProfileButton";
import { useUser } from "../../backend/useUser";
import { useNavigate, useLocation } from "react-router-dom";
import Tooltip from "../../ui/components/Tooltip";
import Logo from "../../ui/components/Logo";
import { useConfig } from "../../utils/config";
import ButtonLink from "../../ui/components/ButtonLink";
import { useMediaQuery } from "@mui/material";
import AltPagesButton from "./AltPagesButton";

const Top = styled.div<{ $colorMode: 'light' | 'dark' }>`
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 54px;

    background: ${props => props.$colorMode === 'dark' 
        ? `linear-gradient(to bottom, ${Colors.black} 0%, ${Colors.black} 85%, transparent 100%)`
        : `linear-gradient(to bottom, ${Colors.background} 0%, ${Colors.background} 85%, transparent 100%)`};
    // backdrop-filter: blur(8px);
    
    padding: 0 5px 5px 5px;
    gap: 10px;
    z-index: 100;

    @media (max-width: 430px) {
        gap: 2px;
    }
`;

const Left = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    gap: 5px;
`;

const Middle = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 5px;
`;

const Right = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    flex: 1;
    gap: 5px;

    @media (max-width: 767px) {
        gap: 2px;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 2px 0 8px;
`;

interface TopBarProps {
    type: 'Game' | 'Art' | 'Animate';
    colorMode?: 'light' | 'dark';
}

const TopBar = ({ type, colorMode='dark' }: TopBarProps) => {
    const config = useConfig();
    const { user } = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width: 430px)');

    // console.log('isMobile', isMobile);

    const onLogInClick = () => {
        localStorage.setItem('redirectPath', location.pathname);
        navigate('/login', { state: { from: location } });
    };

    const onSignUpClick = () => {
        localStorage.setItem('redirectPath', location.pathname);
        navigate('/signup', { state: { from: location } });
    };

    const onDiscordClick = () => {
        window.open('https://discord.gg/ENQxsaBJqd', '_blank');
    };

    const onPricingClick = () => {
        const path = '/pricing';
        window.open(path, '_blank');
    };

    return (
        <Top id='top-bar' $colorMode={colorMode}>
            <Left>
                <LogoContainer>
                    <Logo colorMode={colorMode} size={18} text={null} />
                </LogoContainer>
                <AltPagesButton type={type} colorMode={colorMode} isMobile={isMobile} />
            </Left>

            {/* <Middle>

            </Middle> */}

            <Right>
                {(!isMobile && user) && (
                    <ButtonLink
                        size="small"
                        color={colorMode === 'dark' ? 'white' : 'black'}
                        text="Pricing"
                        onClick={onPricingClick}
                    />
                )}
                <Tooltip text={'Join Discord'} colorMode="dark" >
                    <Button size={'tiny'} icon={'discord'} color={colorMode === 'dark' ? 'ghost white' : 'ghost'} onClick={onDiscordClick} />
                </Tooltip>
                {user ? (
                    <ProfileButton config={config} colorMode={colorMode} />
                ) : (
                    <>
                    <Button size={'tiny'} text={'Log In'} color={colorMode === 'dark' ? 'ghost white' : 'ghost'} onClick={onLogInClick} />
                    <Button size={'tiny'} text={'Sign Up'} color={colorMode === 'dark' ? 'white' : 'black'} onClick={onSignUpClick} />
                    </>
                )}
            </Right>
        </Top>
    );
};

export default TopBar;